<template>
  <div
    :class="{
      rounded: true,
      'bg-white': !sakertMeddelande.createdByCustomer,
      'bg-avtalat-teal': sakertMeddelande.createdByCustomer,
      'text-white': sakertMeddelande.createdByCustomer,
      'mr-xl': align && sakertMeddelande.createdByCustomer,
      'ml-xl': align && !sakertMeddelande.createdByCustomer,
      'px-sm': true,
      'py-lg': true,
    }"
  >
    <div class="mb-xs flex flex-row items-center justify-between">
      <div class="flex flex-row items-center gap-xs">
        <FontAwesomeIcon
          v-if="sakertMeddelande.createdByCustomer"
          icon="fa-regular fa-user"
          size="xl"
        />
        <FontAwesomeIcon
          v-if="!sakertMeddelande.createdByCustomer"
          icon="fa-regular fa-user-headset"
          size="xl"
        />
        <span>{{ sakertMeddelande.createdBy }}</span>
      </div>
      <span class="justify-self-end">{{
        formatStandardDate(sakertMeddelande.createdAt)
      }}</span>
    </div>
    <RichText
      :text="sakertMeddelande.body"
      :class="{ incoming: sakertMeddelande.createdByCustomer }"
    />
    <div
      class="mt-sm flex flex-col items-start gap-xs"
      v-if="sakertMeddelande.attachments?.length"
    >
      <a
        v-for="(attachment, index) in sakertMeddelande.attachments"
        :key="index"
        :href="attachment.attachmentUrl!"
        target="_blank"
        :class="{
          flex: true,
          'flex-row': true,
          'gap-xs': true,
          'items-center': true,
          'text-white': sakertMeddelande.createdByCustomer,
        }"
      >
        <FontAwesomeIcon icon="fa-regular fa-paperclip" size="sm" />
        <span>{{ attachment.name }}</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPaperclip,
  faUser,
  faUserHeadset,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { formatStandardDate } from "@/common/formatters";
import RichText from "@/components/ui/RichText.vue";
import type { ISakertMeddelande } from "@/composables/KundserviceAppApiClient";

type ConversationBubbleProps = {
  sakertMeddelande: ISakertMeddelande;
  align?: boolean;
};

defineProps<ConversationBubbleProps>();

library.add(faPaperclip, faUser, faUserHeadset);
</script>
